module.exports = __webpack_public_path__ + "resources/img/img_gridgain_apache1_jp.b50c742ea121ebaa1d38ebd6b843a055.png";